import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import IdentifyGraphic01 from '../img/identify-graphic.svg';
//import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

class IdentifyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    };
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }
  onChangeCheckbox() {
    this.setState({
      isChecked: !this.state.isChecked
    });
  }

  render() {
    return (
      <EducationModuleLayout
        progressStage={7}
        childTitle="Identify"
        progressType="identify"
      >
        <section>
          <div className="container">
            <Row className="text-center">
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <h2 className="txt-purple no-bold">
                  Identifying Safety Concerns Requires Early Action
                </h2>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <img
                  className="img-block img-responsive"
                  src={IdentifyGraphic01}
                  alt="Graphic of teacher looking through binoculars"
                />
                <p>
                  Some indicators are particularly concerning and necessitate
                  more immediately connecting the person you’re concerned about
                  to someone in a position to help. Specifically, behaviours,
                  thoughts, and feelings that raise concerns about someone's
                  safety should be treated with <strong>urgency</strong>. These include the
                  following:
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <ul className="list-group">
                  <li className="list-group-item">
                    vague or overt references to harming self or others
                  </li>
                  <li className="list-group-item">
                    vague or overt references to thoughts of suicide
                  </li>
                  <li className="list-group-item">
                    confusion, disorientation, apparent disconnect from reality
                    (written or verbal)
                  </li>
                  <li className="list-group-item">
                    expressions of hopelessness, helplessness, or worthlessness
                    (written or verbal)
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <p>
                  People with challenges to their mental health are no more likely
                  to be violent than anyone else. In fact, people with severe mental
                  illnesses are over 10 times more likely to be victims of violence
                  than the general population. Concerns about anyone's safety at any
                  time should be treated with urgency.
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <p>
                  Later in this module, we will review what steps you should
                  take as part of responding to these types of urgent
                  situations. For now, just remember that{' '}
                  <strong>
                    <em>
                      when you’re concerned that there’s a risk to someone’s safety,
                      a more immediate connection is required.
                    </em>
                  </strong>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="checkMark"
                    name="checkMark"
                    onChange={this.onChangeCheckbox}
                  />
                  <label className="form-check-label" htmlFor="checkMark">
                    Asking you to check this box is our way of drawing your attention
                    to just how important this message is. When you’re concerned that
                    there’s a risk to someone’s safety, a more immediate connection
                    is required.
                  </label>

                  {this.state.isChecked && (
                    <span style={{ fontSize: '30px' }} className="txt-green">
                      AWESOME!
                    </span>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </section>
        {this.state.isChecked && (
          <section>
            <div className="container text-center">
              <Row>
                <Col xs={12}>
                  <Button
                    className="btn btn-purple previous"
                    onClick={() => this.props.history.goBack()}
                  >
                    Previous
                  </Button>
                  <LinkContainer
                    to={url.ASSIST}
                    className="btn btn-purple next"
                  >
                    <Button>Next</Button>
                  </LinkContainer>
                </Col>
              </Row>
            </div>
          </section>
        )}
      </EducationModuleLayout>
    );
  }
}

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyG = IdentifyPage;
export default connect.role(IdentifyG);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyG/index.jsx